import { FC } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import {
  SIMPLE_TASK_FORM,
  SIMPLE_TASK_SCHEMA,
} from 'modules/account/sales/forms/schema';
import { useCreateTask } from 'modules/account/sales/hooks';
import SimpleTaskForm from 'modules/account/sales/forms/SimpleTaskForm';

import { ComponentToRenderGenericProps } from '../GlobalCreate';

const FORM_INIT = {
  title: '',
  dueAt: new Date(),
  priority: 'LOW',
  leadId: '',
  accountUserId: [],
  type: 'TODO',
};

type TaskProps = ComponentToRenderGenericProps;

const Task: FC<TaskProps> = ({ close }) => {
  const { mutate: createTask, isLoading: createLoading } = useCreateTask();

  /**
   * Submits the form to create the deal
   * @param {typeof FORM_INIT} value
   * @param {import('formik').FormikHelpers} formikHelpers
   * @return {void | Promise<any>}
   */
  const onSubmit = async (
    payload: SIMPLE_TASK_FORM,
    { setSubmitting }: FormikHelpers<SIMPLE_TASK_FORM>,
  ) => {
    createTask(payload, {
      onSuccess: close,
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik<SIMPLE_TASK_FORM>
      initialValues={FORM_INIT}
      onSubmit={onSubmit}
      validationSchema={SIMPLE_TASK_SCHEMA}
    >
      {() => <SimpleTaskForm isLoading={createLoading} onCancel={close} />}
    </Formik>
  );
};

export default Task;
